export default __webpack_public_path__ + "static/media/executive-leaders.04475ac6.jpg";